/**
 * Before After Results - Swiper + Before/After slider initialization
 */

if (!customElements.get('before-after-results')) {
  class BeforeAfterResults extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initBeforeAfter();
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSwiper() {
      const swiperEl = this.querySelector('[data-bar-swiper]');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      const prevEl = this.querySelector('[data-bar-prev]');
      const nextEl = this.querySelector('[data-bar-next]');
      const paginationEl = this.querySelector('[data-bar-pagination]');

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 6,
        centerInsufficientSlides: true,
        noSwiping: true,
        noSwipingSelector: '[data-ba-handle], [data-ba-line], [data-before-after]',
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        pagination: {
          el: paginationEl,
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 18,
            allowTouchMove: false
          }
        }
      });
    }

    initBeforeAfter() {
      const containers = this.querySelectorAll('[data-before-after]');
      if (!containers.length) return;

      containers.forEach((container) => this.setupSlider(container));
    }

    setupSlider(container) {
      const handle = container.querySelector('[data-ba-handle]');
      const line = container.querySelector('[data-ba-line]');
      const beforeEl = container.querySelector('[data-ba-before]');
      const afterEl = container.querySelector('[data-ba-after]');

      if (!handle || !line || !beforeEl || !afterEl) return;

      let isDragging = false;
      let position = 50;

      const updatePosition = (percentage) => {
        position = Math.max(0, Math.min(100, percentage));
        const pos = position + '%';

        handle.style.left = pos;
        line.style.left = pos;
        beforeEl.style.clipPath = 'polygon(0% 0%, ' + pos + ' 0%, ' + pos + ' 100%, 0% 100%)';
        afterEl.style.clipPath = 'polygon(' + pos + ' 0%, 100% 0%, 100% 100%, ' + pos + ' 100%)';
      };

      const getPercentage = (e) => {
        const rect = container.getBoundingClientRect();
        if (rect.width === 0) return position;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      };

      const onStart = (e) => {
        isDragging = true;
        if (this.swiper) this.swiper.allowTouchMove = false;
        updatePosition(getPercentage(e));
        e.preventDefault();
        e.stopPropagation();
      };

      const onMove = (e) => {
        if (!isDragging) return;
        updatePosition(getPercentage(e));
        e.preventDefault();
      };

      const onEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        if (this.swiper && window.innerWidth < 750) this.swiper.allowTouchMove = true;
      };

      handle.addEventListener('mousedown', (e) => {
        isDragging = true;
        if (this.swiper) this.swiper.allowTouchMove = false;
        updatePosition(getPercentage(e));
        e.preventDefault();
      });

      handle.addEventListener('touchstart', (e) => {
        isDragging = true;
        if (this.swiper) this.swiper.allowTouchMove = false;
        updatePosition(getPercentage(e));
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });

      line.addEventListener('mousedown', (e) => {
        isDragging = true;
        if (this.swiper) this.swiper.allowTouchMove = false;
        updatePosition(getPercentage(e));
        e.preventDefault();
      });

      line.addEventListener('touchstart', (e) => {
        isDragging = true;
        if (this.swiper) this.swiper.allowTouchMove = false;
        updatePosition(getPercentage(e));
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });

      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);

      updatePosition(50);
    }
  }

  customElements.define('before-after-results', BeforeAfterResults);
}
